import React, { useEffect } from "react";
import { Grid } from "@mui/material";

const ProviderReviews = ({ companyName, rating, elfsightCode, buttonText, buttonLink }) => {
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;

  // Extract class name if full HTML snippet was pasted
  let elfsightClass = elfsightCode || '';
  const classMatch = elfsightClass.match(/class="(elfsight-app-[^"]+)"/);
  if (classMatch) {
    elfsightClass = classMatch[1];
  }
  elfsightClass = elfsightClass.trim();

  useEffect(() => {
    if (!document.querySelector('script[src="https://elfsightcdn.com/platform.js"]')) {
      const script = document.createElement("script");
      script.src = "https://elfsightcdn.com/platform.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <Grid container style={{ padding: isMobile ? '60px 30px' : '60px 60px', width: '100%' }}>
      <Grid size={12}>
        <h3 style={{ margin: 0, marginBottom: 0, fontSize: "26px", color: "#000" }}>
          Customer Reviews
        </h3>
        {companyName && rating && (
          <p style={{ margin: 0, marginTop: 8, marginBottom: 20, fontSize: "16px" }}>
            {companyName} are highly rated with a {rating}/5 star customer satisfaction score.
          </p>
        )}
      </Grid>
      {elfsightClass && (
        <Grid size={12} style={{ marginTop: 10 }}>
          <div
            className={elfsightClass}
            data-elfsight-app-lazy
          ></div>
        </Grid>
      )}
      {buttonText && buttonLink && (
        <Grid size={12} style={{ display: 'flex', justifyContent: 'center', marginTop: 40 }}>
          <a
            href={buttonLink}
            target="_blank"
            rel="noopener noreferrer"
            className="trustpilot-btn"
          >
            {buttonText}
          </a>
        </Grid>
      )}
    </Grid>
  );
};

export default ProviderReviews;
